export function toDMSWithDirection(decimal: number, isLat: boolean): string {
  const dir = decimal >= 0
    ? (isLat ? 'B' : 'Đ')
    : (isLat ? 'N' : 'T');
  const absDecimal = Math.abs(decimal);
  let deg = Math.floor(absDecimal);
  let minFloat = (absDecimal - deg) * 60;
  let min = Math.floor(minFloat);
  let sec = Math.round((minFloat - min) * 60);
  while (sec >= 60) {
    sec -= 60;
    min += 1;
  }
  while (min >= 60) {
    min -= 60;
    deg += 1;
  }
  return `${deg}°${min}′${sec}″ ${dir}`;
}